<template>
    <div class="soundlab block">
        <b-row>
            <b-col class="col__text">

                <div class="d-flex soundlab__title">
                    <transition name="fade" mode="out-in">
                        <div v-if="language === 'HU'" key="soundlab-hu" class="d-flex">
                            <P class="font__futura-pt-bold">AKTUÁLIS LEJÁTSZÁSI LISTA</P>
                        </div>

                        <div v-if="language === 'EN'" key="soundlab-en" class="d-flex">
                            <p class="font__futura-pt-bold">TRENDING PLAYLIST</p>
                        </div>
                    </transition>
                </div>

                <transition name="fade" mode="out-in">
                    <div v-if="language === 'HU'" key="about-hu">
                        <p class="font__futura-book-std text">
                            Háttérzenei tartalmak promóciós célra, filmekhez, podcastokhoz és egyéni felhasználásra.
                            A demó lejátszási lista alább hallgatható. Ha szeretnél részleteket megtudni, vagy igényt tartasz a teljes verzióra, írj nekünk!
                        </p>
                        <p class="font__futura-std-heavy text">Felhasználási jog elérhetõ promóciós-, reklám- és egyéb kereskedelmi célokhoz.
                            Csak egyedi árszabással dolgozunk.
                        </p>
                    </div>

                    <div v-if="language === 'EN'" key="about-en">
                        <p class="font__futura-book-std text">
                          Music for ads, films, podcasts, mood videos or any background music licensing. Listen to a demo playlist in 320 kbs here. If you require detailed full versions for sync, please contact us directly.
                        </p>
                        <p class="font__futura-std-heavy text">License available for advertising and B2B commercials.
                            <br/>Unlisted pricing only.</p>
                    </div>
                </transition>

                <div class="portfolio__elems-filter">

                  <p :class="{'active': current === 2}" class="font__futura-pt-bold" @click="setActive(2)">Bass</p>
                  <p :class="{'active': current === 3}" class="font__futura-pt-bold" @click="setActive(3)">Beats</p>
                  <p :class="{'active': current === 0}" class="font__futura-pt-bold" @click="setActive(0)">Vibes</p>

                    <p :class="{'active': current === 1}" class="font__futura-pt-bold" @click="setActive(1)">Atmo</p>



                    <p :class="{'active': current === 4}" class="font__futura-pt-bold" @click="setActive(4)">Custom</p>
                </div>

                <div class="portfolio__elems">

                    <transition name="fade" mode="out-in">
                    <div v-if="current === 0" key="current1">
                        <div class="portfolio__elems-el">
                            <p>01</p>
                          <vue-plyr>
                            <audio controls><source src="../assets/music/VIBES/02_ASANBUDAPEST-Vibes02.mp3" type="audio/mpeg"> </audio>
                          </vue-plyr>
                            <p @click="getMusic('VIBES - 01')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>02</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/VIBES/03_ASANBUDAPEST-Vibes03.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('VIBES - 02')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>03</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/VIBES/06_ASANBUDAPEST-Vibes06.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('VIBES - 03')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>04</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/VIBES/04_ASANBUDAPEST-Vibes04.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('VIBES - 04')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>05</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/VIBES/05_ASANBUDAPEST-Vibes05.mp3" type="audio/mpeg"> </audio></vue-plyr>

                            <p @click="getMusic('VIBES - 05')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>06</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/VIBES/07_ASANBUDAPEST-Vibes07.mp3" type="audio/mpeg"> </audio></vue-plyr>

                            <p @click="getMusic('VIBES - 06')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>07</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/VIBES/07a_ASANBUDAPEST-Vibes09.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('VIBES - 07')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>08</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/VIBES/08_ASANBUDAPEST-Vibes08.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('VIBES - 08')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>09</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/VIBES/12_ASANBUDAPEST-Vibes12.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('VIBES - 09')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>10</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/VIBES/10_ASANBUDAPEST-Vibes10.mp3" type="audio/mpeg"> </audio></vue-plyr>

                            <p @click="getMusic('VIBES - 10')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>11</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/VIBES/13_ASANBUDAPEST-Vibes13.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('VIBES - 11')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>12</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/VIBES/14_ASANBUDAPEST-Vibes14.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('VIBES - 12')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>13</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/VIBES/15_ASANBUDAPEST-Vibes11.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('VIBES - 0')">{{getItLabel}}</p>
                        </div>

                    </div>
                    <div v-if="current === 1" key="current2">
                        <div class="portfolio__elems-el">
                            <p>01</p>

                             <vue-plyr><audio controls crossorigin playsinline>
                                 <source src="../assets/music/ATMO/01_ASANBUDAPEST-Atmosphere01.mp3" type="audio/mp3"/>
                                 </audio></vue-plyr>
                            <p @click="getMusic('ATMO - 01')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>02</p>
                             <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/ATMO/02_ASANBUDAPEST-Atmosphere02.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('ATMO - 02')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>03</p>
                             <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/ATMO/03_ASANBUDAPEST-Atmosphere03.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('ATMO - 03')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>04</p>
                             <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/ATMO/04_ASANBUDAPEST-Atmosphere04.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('ATMO - 04')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>05</p>
                             <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/ATMO/05_ASANBUDAPEST-Atmosphere05.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('ATMO - 05')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>06</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/ATMO/06_ASANBUDAPEST-Atmosphere06.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('ATMO - 06')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>07</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/ATMO/09_ASANBUDAPEST-Atmosphere09.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('ATMO - 07')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>08</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/ATMO/08_ASANBUDAPEST-Atmosphere08.mp3" type="audio/mpeg"> </audio></vue-plyr>

                            <p @click="getMusic('ATMO - 08')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>09</p>
                          <vue-plyr>
                            <audio controls crossorigin playsinline >
                              <source  src="../assets/music/VIBES/01_ASANBUDAPEST-Vibes01.mp3" type="audio/mpeg">
                            </audio></vue-plyr>
                            <p @click="getMusic('ATMO - 09')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>10</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/ATMO/11_ASANBUDAPEST-Atmosphere11.mp3" type="audio/mpeg"> </audio></vue-plyr>


                            <p @click="getMusic('ATMO - 10')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>11</p>
                             <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/ATMO/12_ASANBUDAPEST-Atmosphere07.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('ATMO - 11')">{{getItLabel}}</p>
                        </div>
                      <div class="portfolio__elems-el">
                        <p>12</p>
                        <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/ATMO/10_ASANBUDAPEST-Atmosphere10.mp3" type="audio/mpeg"> </audio></vue-plyr>
                        <p @click="getMusic('ATMO - 12')">{{getItLabel}}</p>
                      </div>
                    </div>
                    <div v-if="current === 2" key="current3">
                        <div class="portfolio__elems-el">
                            <p>01</p>
                             <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BASS/01_ASANBUDAPEST-BASS01.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('BASS - 01')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>02</p>
                             <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BASS/02_ASANBUDAPEST-BASS02.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('BASS - 02')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>03</p>
                             <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BASS/07_ASANBUDAPEST-BASS07.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('BASS - 03')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>04</p>
                             <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BASS/08_ASANBUDAPEST-BASS08.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('BASS - 04')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>05</p>
                             <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BASS/03_ASANBUDAPEST-BASS03.mp3" type="audio/mpeg"> </audio></vue-plyr>

                            <p @click="getMusic('BASS - 05')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>06</p>

                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BASS/9a_ASANBUDAPEST-BASS09a.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('BASS - 06')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>07</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BASS/9b_ASANBUDAPEST-BASS9b.mp3" type="audio/mpeg"> </audio></vue-plyr>

                            <p @click="getMusic('BASS - 07')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>08</p>
                             <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BASS/9c_ASANBUDAPEST-BASS09c.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('BASS - 08')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>09</p>
                             <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BASS/10_ASANBUDAPEST-BASS10.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('BASS - 09')">{{getItLabel}}</p>
                        </div>
                    </div>
                    <div v-if="current === 3" key="current4">
                        <div class="portfolio__elems-el">
                            <p>01</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BEATS/02_ASANBUDAPEST-BEATS02.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('BEATS - 01')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>02</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BEATS/02a_ASANBUDAPEST-BEATS05.mp3" type="audio/mpeg"> </audio></vue-plyr>


                            <p @click="getMusic('BEATS - 02')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>03</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BEATS/01_ASANBUDAPEST-BEATS01.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('BEATS - 03')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>04</p>
                             <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BEATS/03_ASANBUDAPEST-BEATS03.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('BEATS - 04')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>05</p>
                             <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BEATS/04_ASANBUDAPEST-BEATS04.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('BEATS - 05')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>06</p>
                             <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BEATS/06_ASANBUDAPEST-BEATS06.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('BEATS - 06')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>07</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BEATS/08_ASANBUDAPEST-BEATS08.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('BEATS - 07')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>08</p>

                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BEATS/09_ASANBUDAPEST-BEATS09.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('BEATS - 08')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>09</p>

                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BEATS/11_ASANBUDAPEST-BEATS11.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('BEATS - 09')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>10</p>

                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BEATS/07_ASANBUDAPEST-BEATS07.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('BEATS - 10')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>11</p>

                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/BEATS/10_ASANBUDAPEST-BEATS10.mp3" type="audio/mpeg"> </audio></vue-plyr>

                            <p @click="getMusic('BEATS - 11')">{{getItLabel}}</p>
                        </div>
                    </div>
                    <div v-if="current === 4" key="current5">
                        <div class="portfolio__elems-el">
                            <p>01</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/CUSTOM/02_ASANBudapest-Custom02.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('CUSTOM - 01')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>02</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/CUSTOM/03_ASANBudapest-Custom03.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('CUSTOM - 02')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>03</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/CUSTOM/04_ASANBudapest-Custom04.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('CUSTOM - 03')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>04</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/CUSTOM/11_ASANBudapest-Custom11.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('CUSTOM - 04')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>05</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/CUSTOM/07_ASANBudapest-Custom07.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('CUSTOM - 05')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>06</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/CUSTOM/08_ASANBudapest-Custom08.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('CUSTOM - 06')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>07</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/CUSTOM/09_ASANBudapest-Custom09.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('CUSTOM - 07')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>08</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/CUSTOM/06_ASANBudapest-Custom06.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('CUSTOM - 08')">{{getItLabel}}</p>
                        </div>
                        <div class="portfolio__elems-el">
                            <p>09</p>
                          <vue-plyr><audio controls crossorigin playsinline><source src="../assets/music/CUSTOM/10_ASANBudapest-Custom10.mp3" type="audio/mpeg"> </audio></vue-plyr>
                            <p @click="getMusic('CUSTOM - 09')">{{getItLabel}}</p>
                        </div>
                    </div>
                    </transition>
                </div>


            </b-col>
            <b-col>
                <div class="d-flex img-block">
                    <img src="../assets/img/ASAN_04.png" alt="about04"/>
                    <img src="../assets/img/ASAN_05.png" alt="about05"/>
                </div>

                <img id="singleimage" src="../assets/img/ASAN_06.png" alt="about"/>

            </b-col>
        </b-row>
    </div>
</template>

<script>
    export default {
        name: "Soundlab.vue",
        components:{
        },
        computed: {
            language: function () {
                return this.$store.getters.language;
            },
            getItLabel: function () {
                if(this.language === 'EN') return 'GET IT';
                if(this.language === 'HU') return 'KÉREM';
            },
            licenseForLabel: function (){
              if(this.language === 'EN') return 'License for ';
              if(this.language === 'HU') return 'Felhasználási jog: ';
            }
        },
        data: function () {
            return {
                current: 2,

            }
        },
        methods: {
            setActive(index) {
                this.current = index;
                document.querySelector('.portfolio__elems').scrollTop = 0
            },
            getNum(num) {
                if (num >= 10) return num;
                return `0${num}`
            },
            getMusic(subject) {
                this.scroll('block-contact');
                let form = document.getElementById('form-subject');
                form.value = `${this.licenseForLabel}${subject}` ;
            },
            scroll(id) {
                const element = document.getElementById(id);
                const offset = 170;
                const bodyRect = document.body.getBoundingClientRect().top;
                const elementRect = element.getBoundingClientRect().top;
                const elementPosition = elementRect - bodyRect;
                const offsetPosition = elementPosition - offset;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        },
        mounted() {
            document.addEventListener('play', (e) => {
                let audios = document.getElementsByTagName('audio');
                for(let i = 0; i < audios.length; i++){
                  let children = e.target.getElementsByTagName('audio')[0]
                  let source1 = audios[i].getElementsByTagName('source')[0].src;
                  let source2 = children.getElementsByTagName('source')[0].src;
                  if(source1 !== source2){
                    audios[i].pause();
                  }
                }
            }, true);
        }
    }
</script>
<style scoped>
    .row .col:nth-child(1){
        padding-right: 0;
    }

    .row .col:nth-child(2){
        margin-left: 85px;
        padding-right: 0px;
    }
    #singleimage{
        width: 500px;
        margin-top: 10px !important;
        margin-left: -5px;
    }
    .img-block img{
        width: 244px;
    }

    .img-block img:nth-child(1){
        margin-left: -5px;
        margin-right: 12px;
    }
    .text {
        font-size: 12pt;
        letter-spacing: 1px;
        line-height: 21.4pt;
        color: var(--asan-dark-grey)
    }

    .portfolio__elems-el {
        display: flex;
    }



    .portfolio__elems-el p {
        font-family: futura-book-std, serif;
        font-size: 10pt;
        text-transform: uppercase;
        color: #BABCBE;
        margin-top: 17px;
        letter-spacing: 1pt;
        margin-left: 10px;
        cursor: pointer;
    }

    .portfolio__elems-el p:nth-child(1){
        font-family: futura-pt-bold, serif;
        color: var(--asan-dark-grey);
        font-size: 18pt;
        letter-spacing: 2pt;
        margin-top: 8px;
        pointer-events: none;
    }

    .portfolio__elems-el p:hover {
        color: var(--asan-dark-grey)
    }

    .portfolio__elems-filter {
        margin-top: 65px;
        /*margin-left: 55px;*/
        display: flex;
    }

    .portfolio__elems-filter p {
        margin-right: 37px;
        cursor: pointer;
        font-size: 18pt;
        text-transform: uppercase;
        color: #BABCBE;
        letter-spacing: 2.2pt;
        text-decoration: none;
        display: inline-block;
        position: relative;
    }

    .portfolio__elems-filter p:hover {
        color: var(--asan-dark-grey)
    }


    /*.portfolio__elems-filter p:after {*/
    /*    background: none repeat scroll 0 0 transparent;*/
    /*    bottom: -1px;*/
    /*    content: "";*/
    /*    display: block;*/
    /*    height: 1px;*/
    /*    left: 50%;*/
    /*    position: absolute;*/
    /*    background: var(--asan-dark-grey);*/
    /*    transition: width 0.3s ease 0s, left 0.3s ease 0s;*/
    /*    width: 0;*/
    /*}*/

    /*.portfolio__elems-filter p:hover:after {*/
    /*    width: 100%;*/
    /*    left: 0;*/
    /*}*/

    .active {
        color: var(--asan-dark-grey) !important;
    }

    .portfolio__elems {
        overflow-y: scroll;
        margin-top: -5px;
        height: 550px;
        width: 505px;
        margin-left: -10px;
        padding-top:20px
    }


    .col__text .text {
        /*font-size: 16pt;*/
    }

    .col__text {
        /*padding-right: 140px;*/
    }

    .soundlab__title {
        margin-bottom: 20px;
    }

    .soundlab__title p {
        font-size: 22pt;
        letter-spacing: 2px;
        color: var(--asan-dark-grey);
    }

    img {
        width: 450px;
        margin-top: 15px;
    }

</style>